import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { WalletConnectService } from 'src/app/services/wallet-connect.service';
import { convertNum } from 'src/app/shared/constants/app-enums';



@Component({
  selector: 'app-connect',
  templateUrl: './connect.component.html',
  styleUrls: ['./connect.component.scss']
})

export class ConnectComponent implements OnInit {

  step: number = 0;

  constructor(
    public modalRef: BsModalRef,
    private walletConnectService: WalletConnectService
  ) {}

  ngOnInit(): void {
  }

  connectWallet(mode: string): void {
    this.walletConnectService.connectWallet(mode);
    this.modalRef.hide();
  };
}
